import FormattedMessage from 'I18n/components/FormattedMessage';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import { ENTERPRISE } from 'pricing-pages-ui/constants/routing/Tabs';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
// @ts-expect-error image import
import WHEEL from 'bender-url!pricing-pages-ui/img/splash-page/ConnectedCustomerPlatform_Graphic_2x.webp';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import SignupButton from '../common/SignupButton';
import { Container, Section, SectionHeader, SectionSubTitle, SectionTitle } from './SplashPageSharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFlex = styled(UIFlex).withConfig({
  displayName: "PowerOfHubSpotSection__StyledFlex",
  componentId: "sc-1iirwmf-0"
})(["gap:60px;"]);
const StyledTitle = styled(SectionTitle).withConfig({
  displayName: "PowerOfHubSpotSection__StyledTitle",
  componentId: "sc-1iirwmf-1"
})(["text-align:left;margin-bottom:40px;"]);
const StyledSubTitle = styled(SectionSubTitle).withConfig({
  displayName: "PowerOfHubSpotSection__StyledSubTitle",
  componentId: "sc-1iirwmf-2"
})(["text-align:left;margin-bottom:40px;"]);
const PowerOfHubSpotSection = ({
  sourceId,
  selectedTab = ENTERPRISE
}) => {
  const isInApp = useSelector(isAppAuthSelector);
  const imageToShow = WHEEL;
  return /*#__PURE__*/_jsx(Section, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(StyledFlex, {
        justify: "between",
        align: "center",
        children: [/*#__PURE__*/_jsxs(SectionHeader, {
          children: [/*#__PURE__*/_jsx(StyledTitle, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "splash-page.powerOfHubSpot.title"
            })
          }), /*#__PURE__*/_jsx(StyledSubTitle, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `splash-page.powerOfHubSpot.description.${selectedTab}`
            })
          }), !isInApp && /*#__PURE__*/_jsx(SignupButton, {
            use: "primary",
            productLine: "crm",
            sourceId: sourceId
          })]
        }), /*#__PURE__*/_jsx(UIImage, {
          src: imageToShow,
          style: {
            maxWidth: '50%'
          }
        })]
      })
    })
  });
};
export default PowerOfHubSpotSection;